import TripsHomeView from '@/views/TripsHomeView.vue'
import { createRouter, createWebHistory } from 'vue-router'

export enum RouteNames {
  home = 'home',
  trips = 'trips',
  tripAddDestination = 'tripAddDestination',
  tripAddOrigin = 'tripAddOrigin',
  tripAddDetails = 'tripAddDetails',
  tripItinerary = 'tripItinerary',
  tripStats = 'tripStats',
  fleetVehicle = 'fleetVehicle',
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: RouteNames.home,
      redirect: '/trips',
    },
    {
      path: '/trips',
      children: [
        {
          path: '',
          name: RouteNames.trips,
          component: TripsHomeView,
        },
      ],
    },
    {
      path: '/login/:location?',
      component: () => import('@/views/ReturningLoginView.vue'),
      meta: {
        section: 'utility',
      },
    },
    {
      path: '/accept-invite/:inviteId?',
      component: () => import('@/views/AcceptInviteView.vue'),
      meta: {
        section: 'utility',
      },
    },
    {
      path: '/subscription',
      component: () => import('@/views/ReturningSubscriptionView.vue')
    },
    {
      path: '/trip/planning',
      children: [
        {
          path: 'add-destination',
          name: RouteNames.tripAddDestination,
          component: () => import('@/views/PlanningAddDestinationView.vue'),
          meta: {
            section: 'trip',
            breadcrumbMode: 'trip',
          },
        },
        {
          path: 'add-origin',
          name: RouteNames.tripAddOrigin,
          component: () => import('@/views/PlanningAddOriginView.vue'),
          meta: {
            section: 'trip',
            breadcrumbMode: 'trip',
          },
        },
        {
          path: 'add-details',
          name: RouteNames.tripAddDetails,
          component: () => import('@/views/PlanningAddDetailsView.vue'),
          meta: {
            section: 'trip',
          },
        },
        {
          path: 'itinerary',
          name: RouteNames.tripItinerary,
          component: () => import('@/views/PlanningItineraryView.vue'),
          meta: {
            section: 'trip',
          },
        },
        {
          path: 'trip-stats',
          name: RouteNames.tripStats,
          component: () => import('@/views/TripStatsView.vue'),
          meta: {
            section: 'trip',
          },
        },
      ],
    },
    {
      name: RouteNames.fleetVehicle,
      path: '/fleet/vehicle',
      component: () => import('@/views/FleetVehicleView.vue'),
    },
    { path: '/:pathMatch(.*)*', component: () => import('@/views/PageNoteFoundView.vue') },
  ],
})

export default router
